module.exports = __webpack_public_path__ + "img/51626524.3c3b1b60.png";